module.exports = __webpack_public_path__ + "img/report-2.1b28de68.jpg";